import generalSection from "../_section/section.class";
import {adminReturnToWorkLetterUpload, userReturnToWorkLetterUpload} from "./upload";
import DataForm from "./DataForm";

export class userReturnToWorkLetterSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userReturnToWorkLetterUpload);
        // Add missing date error

    }
}

export class adminReturnToWorkLetterSection extends userReturnToWorkLetterSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminReturnToWorkLetterUpload);
        this.DataForm = DataForm
        this.sortByDateProp('documentDate');
        this.activeUpload = this.activeUploads.find(u=> u.allValuesAnswered && u.isVerifiable)
        this.setProblems(this.problemsList.singleUploadUserProblems())
    }


    get documentDate() {
        if (this.activeUpload && this.activeUpload.values.documentDate) {
            return this.activeUpload.values.documentDate;
        }
        return null;
    }

    get returnDate() {
        if (this.activeUpload && this.activeUpload.values.returnDate) {
            return this.activeUpload.values.returnDate;
        }
        return null;
    }

    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags: [
                    {
                        name: 'Document Date',
                        value: this.documentDate ? this.documentDate.format('D MMM YYYY') : 'N/A'
                    },
                    {
                        name: 'Return Date',
                        value: this.returnDate ? this.returnDate.format('D MMM YYYY') : 'N/A'
                    },
                    {
                        name: 'Return Salary',
                        value: this.activeUpload?.values?.returnSalary || 'N/A'
                    },
                    {
                        name: 'Return Position',
                        value: this.activeUpload?.values?.returnPosition || 'N/A'
                    }
                ]
            }
        ]
    }
}